import { ArrowPathIcon, MagnifyingGlassIcon, TrashIcon } from "@heroicons/react/20/solid"
import MainStore from "./MainStore"
import useDataEvent from "./CustomHook"
import { QueryPane } from "./QueryPane"
import Panel from "./Panel"
import { Badge, BadgeButton } from "./@components/badge"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Accordion, AccordionItem, Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from "@heroui/react"

const mainstore = MainStore()

export default function SearchSet({primitive, searchPrimitive, resultSet, filters, toggleFilter, searchCategoryIds, props}){
    useDataEvent("set_field set_parameter", [primitive?.id, searchPrimitive?.id])

        const searches = searchPrimitive ? [searchPrimitive] : primitive.primitives.search?.[resultSet] 
        const hasSearches = (searches && searches.length > 0)
        
        
        const createSearch = async (id)=>{

            const path = `search.${resultSet}`
            const createId = id ?? searchCategoryIds?.[0]
            console.log(`will create ${createId} at ${path}`)
            const newPrim = await MainStore().createPrimitive({type: 'search', parent: primitive, categoryId: createId , parentPath: path})
        }
        
        let createSearchButton
        if(!searchCategoryIds || searchCategoryIds.length === 1){
            if( hasSearches ){
                createSearchButton = (
                  <Button
                    size="sm"
                    variant="light"
                    startContent={<MagnifyingGlassIcon className="h-4" />}
                    onPress={()=>createSearch()}
                  >
                    New search
                  </Button>
                )
            }else{
                createSearchButton = (
                  <Button
                    variant="light"
                    onPress={()=>createSearch()}
                    className="text-center"
                  >
                    Create a new query
                  </Button>
                )
            }
        }else{
            createSearchButton = (
              <Dropdown>
                <DropdownTrigger>
                  <Button size={hasSearches ? "sm" : "md"} variant="light" startContent={<MagnifyingGlassIcon className="h-4" />}>
                    New search
                  </Button>
                </DropdownTrigger>
                <DropdownMenu
                  aria-label="Search categories"
                  onAction={(key)=>createSearch(key)}
                >
                  {searchCategoryIds.map((id)=>{
                    const cat = MainStore().category(id)
                    return <DropdownItem key={cat.id}>{cat.title}</DropdownItem>
                  })}
                </DropdownMenu>
              </Dropdown>
            )
        }

        
        return <div className={`${hasSearches ? "py-2" : "p-2"} bg-slate-50 border m-2 rounded-lg divide-y divide-gray-200 border-b border-gray-300`}>
                {!hasSearches && <div className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400">{createSearchButton}</div>}
                {searches && searches.length > 0 && <>
                    {searches.map(d=>{
                    return (
                    <div key={d.id} className="group w-full py-2 px-4 space-y-1  hover:bg-gray-50 ">
                        <Accordion
                          isCompact
                          selectionMode="single"
                          itemClasses={{
                            base: "px-2 border border-gray-200 rounded-md",
                            title: "text-sm",
                          }}
                        >
                          <AccordionItem
                            key={d.id}
                            aria-label={`Search ${d.title}`}
                            title={
                              <div className="flex items-center gap-2 w-full">
                                <MagnifyingGlassIcon className="h-4" />
                                <p className="w-full text-left">{d.title}</p>
                                <BadgeButton
                                  onClick={(e)=>{
                                    e.stopPropagation()
                                    toggleFilter && toggleFilter({type: "parent", id: primitive.id})
                                  }}
                                  color={filters && filters.find(d2=>d2.type === "parent" && d2.id === primitive.id) ? "lime" : "zinc"}
                                >
                                  {d.primitives.uniqueAllIds.length} items
                                </BadgeButton>
                                <Button
                                  isIconOnly
                                  size="sm"
                                  variant="light"
                                  onPress={()=>mainstore.doPrimitiveAction(d, "query")}
                                >
                                  <ArrowPathIcon className="h-4 w-4" aria-hidden="true" />
                                </Button>
                                <Button
                                  isIconOnly
                                  size="sm"
                                  variant="light"
                                  onPress={()=>mainstore.promptDelete({prompt: "Remove search and all results?", handleDelete: ()=>mainstore.removePrimitive(d)})}
                                >
                                  <FontAwesomeIcon icon="trash" />
                                </Button>
                              </div>
                            }
                          >
                            <div className="mt-4">
                              <QueryPane primitive={d} toggleFilter={toggleFilter} filters={filters}/>
                              <span className="text-gray-400 text-xs">#{d.plainId}  {d.metadata.title ?? "Search"}</span>
                            </div>
                          </AccordionItem>
                        </Accordion>
                    </div>
                )}) }
                {!searchPrimitive && <div className="px-4 pt-2">
                    {createSearchButton}
                </div>}
                </>
                }
            </div>
}
